import omit from 'lodash.omit';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import overrideStyle from 'lib/overrideStyle';
import styles from 'presentation/components/styles/InputBox.css';
let cx = classnames.bind(styles);

class InputBox extends React.Component {
  constructor(props) {
    super(props);
  }

  focus() {
    this.textInput.focus();
  }

  render() {
    let renderProps = omit(this.props, ['className', 'onChange', 'prompt']);
    return (
      <div
        className={cx(
          styles.inputBox,
          this.props.className,
          this.props.hasAttachments ? styles.inputBox_withAttachments : ''
        )}
      >
        <TextArea
          id={'gladlyTextBox'}
          className={cx(styles.inputBox_textarea, 'inputBox_textArea')}
          maxLength={1000}
          onChange={this.props.onChange}
          onKeyDown={this.props.onKeyDown}
          placeholder={this.props.prompt}
          value={this.props.value}
          ref={textInput => (this.textInput = textInput)}
          {...renderProps}
        />
      </div>
    );
  }
}

export default InputBox;

InputBox.propTypes = {
  prompt: PropTypes.string.isRequired,
  value: PropTypes.string,
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func.isRequired,
};

const TextArea = overrideStyle('textarea')`
  font-family: ${p => p.theme.fontLibrary.secondary};
  &::placeholder {
    overflow: hidden;
  }
`;
